import React from "react";
import { getAppraiserIndicatorMeta } from "../api/AppraiserIndicatorUtil.tsx";

interface AIBadgeProps {
    attentionIndicator: string;
    size?: "default" | "small";
}

export const AIBadge: React.FC<AIBadgeProps> = ({ attentionIndicator, size = "default" }) => {
    if (!attentionIndicator) {
        return null;
    }
    // Get the appropriate metadata for this indicator
    const metadata = getAppraiserIndicatorMeta(attentionIndicator);

    // Determine sizing based on the size prop
    const padding = size === "small" ? "px-1.5 py-0.5" : "px-2 py-1";
    const fontSize = size === "small" ? "text-xs" : "text-xs"; // Both are xs for now, but you could use 'text-[10px]' for smaller
    const iconSize = size === "small" ? "w-3 h-3" : "w-4 h-4";

    return (
        <span className={`inline-flex items-center gap-1 ${padding} rounded-full ${fontSize} font-medium ${metadata.bgColor} ${metadata.textColor}`}>
            <span className={`${metadata.iconColor} flex items-center justify-center ${iconSize}`}>
                {metadata.icon}
            </span>
            <span>{attentionIndicator}</span>
        </span>
    );
};